// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import config from '../../../IncrencyConfig-LabSystem_LIIMS.json'

export const environment = {
  production: false,
  ApiHost: {
    "host": config.host.match(/62.171.187.143/gi) != null ? 'tantrasoft.in' : config.host,
    "WebPort": config.WebPort,
    "APIPORT": config.APIPORT,
  }
};
